import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { defaultTemplate } from 'core/hoc';
import { dateFormatter } from 'core/utils';
import moment from 'moment';

const DatePickerTemplate = function({
    value,
    onChange,
    format = 'kendo-input-short',
    max,
    disabled,
    customFormat,
    formatPlaceholder,
    ...otherProps
}) {

    function internalOnChange(event) {
        if (onChange) {
            let val = moment(event.value).format('YYYY-MM-DD');
            onChange(
                val !== 'Invalid date'
                    ? new Date(new Date(event.value).setHours(12, 0, 0, 0))
                    : event.value
            );
        }
    }

    function handleClear() {
        if (onChange) {
            onChange(null); // Clear the date
        }
    }

    return (
        <div className='date-picker'>
            <DatePicker
                {...otherProps}
                disabled={disabled}
                value={value}
                max={max}
                format={customFormat === undefined ? dateFormatter.map(format) : customFormat}
                onChange={internalOnChange}
                formatPlaceholder={formatPlaceholder || { year: 'year', month: 'month', day: 'day' }}
            />

            {value && <button
                type="button"
                disabled={disabled}
                className="is-clear"
                onClick={handleClear}
                aria-label="Clear date"
            >
                <i className='u-icon u-icon--xsml u-icon--close--primary'></i>
            </button>}
        </div>
    );
};

DatePickerTemplate.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.instanceOf(Date),
    format: PropTypes.string,
    min: PropTypes.instanceOf(Date),
    max: PropTypes.instanceOf(Date),
    show: PropTypes.bool,
    disabled: PropTypes.bool,
    customFormat: PropTypes.any,
    formatPlaceholder: PropTypes.any
};

export default defaultTemplate(DatePickerTemplate);
